import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const MuiTextField: {
  defaultProps?: ComponentsProps['MuiTextField'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTextField'];
  variants?: ComponentsVariants['MuiTextField'];
} = {
  defaultProps: {
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    },
    autoComplete: 'off'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiOutlinedInput-notchedOutline': {
        '& legend': {
          display: 'none'
        }
      },
      '& .MuiInputLabel-root': {
        transform: 'none',
        position: 'relative',
        marginBottom: theme.spacing(1)
      }
    })
  }
};
